import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { AuthData } from 'app/shared/models/class/auth/auth-data';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { SubscriptionBaseComponent } from 'app/shared/subscription-base/subscription-base-component';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.scss']
})
export class SignInComponent extends SubscriptionBaseComponent implements OnInit {

  singInForm!: UntypedFormGroup;
  color: ThemePalette = 'accent';

  logInProgress: boolean = false;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private authService: AuthService
  ) {
    super();
  }

  ngOnInit(): void {
    this.initForm();
    this.initSub();
  }

  onSubmit(): void {
    const newUser = new AuthData(this.f.username.value, this.f.password.value);
    this.authService.login(newUser)

  }

  get f() {
    return this.singInForm.controls
  }

  private initForm(): void {
    this.singInForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    })
  }

  private initSub(): void {
    this.subscription
      .add(
        this.authService.logInProgress$.subscribe({
          next: logInProgress => {
            this.logInProgress = logInProgress;
            if (!logInProgress) {
              this.f.password.reset();
            }
          }
        })
      )
  }

}
